import { makeObservable } from "mobx";
import { AddStudentViewModel } from "../AddStudentViewModel";

/**
 * Minimal MobX manager for AddStudentViewModel.
 * The existing observable state lives on the model and is exposed via ViewModelBase getters.
 * This class exists to satisfy the ManagersModule contract and for future state expansion.
 */
export class MobXManager {
    constructor(private viewModel: AddStudentViewModel) {
        makeObservable(this, {});
    }
}
